import { type } from "jquery"
import { Abstract } from "./Presets/abstract"
import { Alphabet } from "./Presets/alphabet"
import { Baloons } from "./Presets/baloons"
import { Blot } from "./Presets/blot"
import { Blur } from "./Presets/blur"
import { Bubble } from "./Presets/bubble"
import { China } from "./Presets/china"
import { Circles } from "./Presets/circles"
import { City } from "./Presets/city"
import { Crowns } from "./Presets/crowns"
import { Emoji } from "./Presets/emoji"
import { Flowers } from "./Presets/flowers"
import { Forms } from "./Presets/forms"
import { Geometry } from "./Presets/geometry"
import { Hourglass } from "./Presets/hourglass"
import { Marble } from "./Presets/marble"
import { Mountains } from "./Presets/mountains"
import { Music } from "./Presets/music"
import { Noses } from "./Presets/noses"
import { Party } from "./Presets/party"
import { Plants } from "./Presets/plants"
import { Sale } from "./Presets/sale"
import { Squares } from "./Presets/squares"
import { Stars } from "./Presets/stars"
import { Stones } from "./Presets/stones"
import { Stripes } from "./Presets/stripes"
import { TicTacToe } from "./Presets/tictactoe"
import { Waves } from "./Presets/waves"
import { Winter } from "./Presets/winter"
import { ZigZag } from "./Presets/zigzag"

import vanta_birds from './Presets/preview_3d/vanta_birds.png'
import vanta_fog from './Presets/preview_3d/vanta_fog.png'
import vanta_waves from './Presets/preview_3d/vanta_waves.png'
import vanta_clouds from './Presets/preview_3d/vanta_clouds.png'
import vanta_net from './Presets/preview_3d/vanta_net.png'
import vanta_globe from './Presets/preview_3d/vanta_globe.png'
import vanta_cells from './Presets/preview_3d/vanta_cells.png'
import vanta_trunk from './Presets/preview_3d/vanta_trunk.png'
import vanta_topology from './Presets/preview_3d/vanta_topology.png'
import vanta_dots from './Presets/preview_3d/vanta_dots.png'
import vanta_rings from './Presets/preview_3d/vanta_rings.png'
import vanta_halo from './Presets/preview_3d/vanta_halo.png'
import custom_aurora from './Presets/preview_3d/custom_aurora.png'
import custom_coalesce from './Presets/preview_3d/custom_coalesce.png'
import custom_pipeline from './Presets/preview_3d/custom_pipeline.png'
import custom_shift from './Presets/preview_3d/custom_shift.png'
import custom_swirl from './Presets/preview_3d/custom_swirl.png'



export const PRESET_TYPE = {
    circles: 'circles',
    stars: 'stars',
    plants: 'plants',
    geometry: 'geometry',
    forms: 'forms',
    abstract: 'abstract',
    blur: 'blur',
    zigzag: 'zigzag',
    winter: 'winter',
    bubble: 'bubble',
    city: 'city',
    music: 'music',
    emoji: 'emoji',
    party: 'party',
    mountains: 'mountains',
    alphabet: 'alphabet',
    flowers: 'flowers',
    stripes: 'stripes',
    hourglass: 'hourglass',
    sale: 'sale',
    stones: 'stones',
    baloons: 'baloons',
    squares: 'squares',
    tictactoe: 'tictactoe',
    marble: 'marble',
    blot: 'blot',
    noses: 'noses',
    waves: 'waves',
    china: 'china',
    crowns: 'crowns',
    default: 'default'
}

// export const presetTypesArray = [PRESET_TYPE.circle, PRESET_TYPE.square, PRESET_TYPE.triangle, PRESET_TYPE.circles, PRESET_TYPE.stars, PRESET_TYPE.colorful, PRESET_TYPE.blur, PRESET_TYPE.curly, PRESET_TYPE.zigzag, PRESET_TYPE.plants, PRESET_TYPE.geometry, PRESET_TYPE.default]
export const presetTypesArray = [
    PRESET_TYPE.circles,
    PRESET_TYPE.stars,
    PRESET_TYPE.abstract,
    PRESET_TYPE.blur,
    PRESET_TYPE.geometry,
    PRESET_TYPE.zigzag,
    PRESET_TYPE.plants,
    PRESET_TYPE.forms,
    PRESET_TYPE.winter,
    PRESET_TYPE.bubble,
    PRESET_TYPE.city,
    PRESET_TYPE.music,
    PRESET_TYPE.emoji,
    PRESET_TYPE.party,
    PRESET_TYPE.mountains,
    PRESET_TYPE.alphabet,
    PRESET_TYPE.flowers,
    PRESET_TYPE.stripes,
    PRESET_TYPE.hourglass,
    PRESET_TYPE.sale,
    PRESET_TYPE.stones,
    PRESET_TYPE.baloons,
    PRESET_TYPE.squares,
    PRESET_TYPE.tictactoe,
    PRESET_TYPE.marble,
    PRESET_TYPE.blot,
    PRESET_TYPE.noses,
    PRESET_TYPE.waves,
    PRESET_TYPE.china,
    PRESET_TYPE.crowns,
]

export const getColorAmountByType = (type) => {
    // switch (type) {
    //     case PRESET_TYPE.circle:
    //         return 2;
    //     case PRESET_TYPE.square:
    //         return 2;
    //     case PRESET_TYPE.triangle:
    //         return 2;
    //     case PRESET_TYPE.zigzag:
    //         return 3;
    //     case PRESET_TYPE.geometry:
    //         return 4;
    //     case PRESET_TYPE.plants:
    //         return 2;
    //     case PRESET_TYPE.colorful:
    //         return 5;
    //     case PRESET_TYPE.blur:
    //         return 5;
    //     default:
    //         return 1;
    // }

    const color = getColorsByType(type)
    return color.length
}

const getViewBoxByType = (type = '') => {
    switch (type) {
        case PRESET_TYPE.stars:
            return '0 0 1920 850';
        case PRESET_TYPE.abstract:
            return '0 0 1920 850';
        case PRESET_TYPE.zigzag:
            return '25 50 1920 750';
        case PRESET_TYPE.forms:
            return '0 135 1920 780';
        case PRESET_TYPE.circles:
            return '0 0 1920 850';
        case PRESET_TYPE.geometry:
            return '0 0 1920 850';
        case PRESET_TYPE.plants:
            return '0 135 1920 780';
        case PRESET_TYPE.blur:
            return '0 0 1920 850';
        case PRESET_TYPE.winter:
            return '25 50 1920 750';
        case PRESET_TYPE.bubble:
            return '0 0 1920 850';
        case PRESET_TYPE.city:
            return '0 0 1920 850';
        case PRESET_TYPE.music:
            return '0 0 1920 850';
        case PRESET_TYPE.emoji:
            return '0 50 1920 750';
        case PRESET_TYPE.party:
            return '0 0 1920 850';
        case PRESET_TYPE.mountains:
            return '0 0 1920 850';
        case PRESET_TYPE.alphabet:
            return '0 50 1920 750';
        case PRESET_TYPE.flowers:
            return '0 0 1920 850';
        case PRESET_TYPE.stripes:
            return '0 0 1920 850';
        case PRESET_TYPE.hourglass:
            return '0 50 1920 750';
        case PRESET_TYPE.sale:
            return '0 50 1920 750';
        case PRESET_TYPE.stones:
            return '0 50 1920 750';
        case PRESET_TYPE.baloons:
            return '0 50 1920 750';
        case PRESET_TYPE.squares:
            return '0 50 1920 750';
        case PRESET_TYPE.tictactoe:
            return '0 50 1920 750';
        case PRESET_TYPE.marble:
            return '0 50 1920 750';
        case PRESET_TYPE.blot:
            return '0 50 1920 750';
        case PRESET_TYPE.noses:
            return '0 50 1920 750';
        case PRESET_TYPE.waves:
            return '0 50 1920 750';
        case PRESET_TYPE.china:
            return '0 50 1920 750';
        case PRESET_TYPE.crowns:
            return '0 50 1920 750';
        default:
            return '0 0 24 24';
    }
}

export const getColorsByType = (type = '') => {
    switch (type) {
        case PRESET_TYPE.plants:
            return ['rgba(115, 91, 161, 1)', 'rgba(255, 255, 255, 1)'];
        case PRESET_TYPE.circles:
            return ['rgba(157, 190, 199, 1)', 'rgba(79, 115, 139, 1)', 'rgba(217, 217, 217, 1)', 'rgba(255, 255, 255, 1)', 'rgba(236, 142, 78, 1)'];
        case PRESET_TYPE.zigzag:
            return ['rgba(251, 255, 255, 1)', 'rgba(229, 217, 205, 1)', 'rgba(206, 215, 230, 1)'];
        case PRESET_TYPE.stars:
            return ['rgba(102, 135, 193, 1)', 'rgba(255, 254, 255, 1)', 'rgba(146, 198, 211, 1)'];
        case PRESET_TYPE.geometry:
            return ['rgba(178, 97, 218, 1)', 'rgba(48, 33, 36, 1)', 'rgba(250, 214, 140, 1)', 'rgba(255, 255, 255, 1)'];
        case PRESET_TYPE.forms:
            return ['rgba(236, 129, 147, 1)', 'rgba(247, 219, 182, 1)', 'rgba(7, 9, 6, 1)', 'rgba(202, 41, 83, 1)'];
        case PRESET_TYPE.abstract:
            return ['rgba(254, 167, 72, 1)', 'rgba(247, 153, 145, 1)', 'rgba(49, 79, 136, 1)', 'rgba(255, 255, 255, 1)', 'rgba(197, 229, 233, 1)'];
        case PRESET_TYPE.blur:
            return ['rgba(201, 204, 248, 1)', 'rgba(212, 169, 243, 1)', 'rgba(252, 141, 218, 1)', 'rgba(187, 247, 255, 1)', 'rgba(255, 255, 255, 1)'];
        case PRESET_TYPE.winter:
            return ['rgba(77, 103, 126, 1)', 'rgba(214, 173, 113, 1)', 'rgba(123, 153, 143, 1)', 'rgba(255, 255, 255, 1)'];
        case PRESET_TYPE.bubble:
            return ['rgba(163, 111, 100, 1)', 'rgba(201, 154, 148, 1)', 'rgba(196, 170, 165, 1)', 'rgba(221, 192, 178, 1)', 'rgba(255, 255, 255, 1)'];
        case PRESET_TYPE.city:
            return ['rgba(26, 27, 44, 1)', 'rgba(111, 174, 211, 1)', 'rgba(255, 255, 255, 1)', 'rgba(255, 234, 4, 1)', 'rgba(151, 175, 197, 1)'];
        case PRESET_TYPE.music:
            return ['rgba(217, 209, 197, 1)', 'rgba(156, 128, 89, 1)', 'rgba(0, 0, 0, 1)'];
        case PRESET_TYPE.emoji:
            return ['rgba(255, 255, 255, 1)', 'rgba(210, 199, 255, 1)', 'rgba(245, 217, 255, 1)'];
        case PRESET_TYPE.party:
            return ['rgba(152, 204, 218, 1)', 'rgba(255, 228, 125, 1)', 'rgba(181, 219, 172, 1)', 'rgba(244, 144, 68, 1)'];
        case PRESET_TYPE.mountains:
            return ['rgba(219, 238, 249, 1)', 'rgba(96, 130, 165, 1)', 'rgba(28, 80, 127, 1)', 'rgba(21, 38, 64, 1)', 'rgba(11, 22, 40, 1)'];
        case PRESET_TYPE.alphabet:
            return ['rgba(44, 44, 44, 1)', 'rgba(94, 80, 72, 1)', 'rgba(98, 85, 77, 1)', 'rgba(171, 156, 146, 1)', 'rgba(129, 109, 98, 1)'];
        case PRESET_TYPE.flowers:
            return ['rgba(58, 88, 182, 1)', 'rgba(174, 197, 235, 1)', 'rgba(209, 124, 125, 1)', 'rgba(143, 185, 166, 1)', 'rgba(237, 240, 244, 1)'];
        case PRESET_TYPE.stripes:
            return ['rgba(193, 205, 221, 1)', 'rgba(253, 143, 146, 1)', 'rgba(216, 99, 105, 1)', 'rgba(252, 209, 207, 1)'];
        case PRESET_TYPE.hourglass:
            return ['rgba(219, 139, 102, 1)', 'rgba(185, 220, 224, 1)', 'rgba(255, 156, 0, 1)', 'rgba(231, 227, 215, 1)', 'rgba(212, 224, 185, 1)'];
        case PRESET_TYPE.sale:
            return ['rgba(211, 57, 55, 1)', 'rgba(172, 44, 42, 1)', 'rgba(240, 115, 113, 1)'];
        case PRESET_TYPE.stones:
            return ['rgba(60, 99, 103, 1)', 'rgba(106, 178, 173, 1)', 'rgba(150, 202, 198, 1)', 'rgba(13, 59, 64, 1)', 'rgba(255, 255, 255, 1)'];
        case PRESET_TYPE.baloons:
            return ['rgba(246, 246, 246, 1)', 'rgba(140, 150, 158, 1)', 'rgba(171, 127, 113, 1)', 'rgba(190, 181, 156, 1)'];
        case PRESET_TYPE.squares:
            return ['rgba(188, 169, 94, 1)', 'rgba(241, 158, 128, 1)', 'rgba(187, 197, 172, 1)', 'rgba(250, 152, 29, 1)'];
        case PRESET_TYPE.tictactoe:
            return ['rgba(226, 220, 84, 1)', 'rgba(101, 74, 39, 1)', 'rgba(190, 224, 199, 1)', 'rgba(50, 149, 82, 1)'];
        case PRESET_TYPE.marble:
            return ['rgba(208, 157, 48, 1)', 'rgba(11, 59, 58, 1)', 'rgba(40, 133, 137, 1)', 'rgba(45, 147, 161, 1)', 'rgba(24, 104, 108, 1)'];
        case PRESET_TYPE.blot:
            return ['rgba(231, 182, 169, 1)', 'rgba(233, 219, 109, 1)', 'rgba(220, 178, 221, 1)', 'rgba(121, 144, 187, 1)', 'rgba(170, 195, 242, 1)'];
        case PRESET_TYPE.noses:
            return ['rgba(251, 185, 140, 1)', 'rgba(85, 61, 55, 1)', 'rgba(248, 209, 183, 1)', 'rgba(245, 231, 218, 1)'];
        case PRESET_TYPE.waves:
            return ['rgba(254, 181, 101, 1)', 'rgba(85, 61, 55, 1)', 'rgba(152, 184, 162, 1)', 'rgba(251, 219, 222, 1)', 'rgba(179, 179, 177, 1)'];
        case PRESET_TYPE.china:
            return ['rgba(55, 80, 164, 1)', 'rgba(233, 101, 89, 1)', 'rgba(255, 200, 203, 1)'];
        case PRESET_TYPE.crowns:
            return ['rgba(221, 187, 177, 1)', 'rgba(240, 203, 148, 1)', 'rgba(172, 126, 67, 1)', 'rgba(195, 89, 63, 1)'];
        default:
            return ['#FFD700'];
    }
}

export const getBackgroundByType = (type = '') => {
    switch (type) {
        case PRESET_TYPE.zigzag:
            return 'rgba(238, 249, 251, 1)'
        case PRESET_TYPE.stars:
            return 'rgba(50, 49, 127, 1)'
        case PRESET_TYPE.forms:
            return 'rgba(250, 176, 103, 1)'
        case PRESET_TYPE.plants:
            return 'rgba(156, 196, 170, 1)'
        case PRESET_TYPE.geometry:
            return 'rgba(221, 187, 248, 1)'
        case PRESET_TYPE.winter:
            return 'rgba(172, 194, 192, 1)'
        case PRESET_TYPE.bubble:
            return 'rgba(234, 223, 219, 1)'
        case PRESET_TYPE.city:
            return 'rgba(35, 38, 69, 1)'
        case PRESET_TYPE.music:
            return 'rgba(237, 236, 233, 1)'
        case PRESET_TYPE.emoji:
            return 'rgba(225, 251, 98, 1)'
        case PRESET_TYPE.party:
            return 'rgba(255, 254, 238, 1)'
        case PRESET_TYPE.mountains:
            return 'rgba(177, 212, 242, 1)'
        case PRESET_TYPE.alphabet:
            return 'rgba(199, 187, 171, 1)'
        case PRESET_TYPE.flowers:
            return 'rgba(183, 194, 182, 1)'
        case PRESET_TYPE.stripes:
            return 'rgba(254, 241, 232, 1)'
        case PRESET_TYPE.hourglass:
            return 'rgba(223, 207, 181, 1)'
        case PRESET_TYPE.sale:
            return 'rgba(245, 183, 198, 1)'
        case PRESET_TYPE.stones:
            return 'rgba(103, 160, 155, 1)'
        case PRESET_TYPE.baloons:
            return 'rgba(201, 209, 215, 1)'
        case PRESET_TYPE.squares:
            return 'rgba(237, 220, 200, 1)'
        case PRESET_TYPE.tictactoe:
            return 'rgba(246, 244, 221, 1)'
        case PRESET_TYPE.marble:
            return 'rgba(187, 214, 209, 1)'
        case PRESET_TYPE.blot:
            return 'rgba(247, 247, 247, 1)'
        case PRESET_TYPE.noses:
            return 'rgba(255, 241, 231, 1)'
        case PRESET_TYPE.waves:
            return 'rgba(243, 249, 239, 1)'
        case PRESET_TYPE.china:
            return 'rgba(178, 194, 216, 1)'
        case PRESET_TYPE.crowns:
            return 'rgba(239, 233, 217, 1)'
        default:
            return 'rgba(255, 255, 255, 1)'
    }
}

const getPathsByType = (type = '', colors = [], uid = '') => {
    const strokeWidth = 5
    switch (type) {
        case PRESET_TYPE.winter:
            return (<Winter colors={colors} uid={uid} />)

        case PRESET_TYPE.stars:
            return (<Stars colors={colors} uid={uid} />)

        case PRESET_TYPE.circles:
            return (<Circles colors={colors} uid={uid} />)

        case PRESET_TYPE.geometry:
            return (<Geometry colors={colors} uid={uid} />)

        case PRESET_TYPE.forms:
            return (<Forms colors={colors} uid={uid} />)

        case PRESET_TYPE.plants:
            return (<Plants colors={colors} uid={uid} />)

        case PRESET_TYPE.zigzag:
            return (<ZigZag colors={colors} uid={uid} />)

        case PRESET_TYPE.abstract:
            return (<Abstract colors={colors} uid={uid} />)

        case PRESET_TYPE.blur:
            return (<Blur colors={colors} uid={uid} />)

        case PRESET_TYPE.bubble:
            return (<Bubble colors={colors} uid={uid} />)

        case PRESET_TYPE.city:
            return (<City colors={colors} uid={uid} />)

        case PRESET_TYPE.music:
            return (<Music colors={colors} uid={uid} />)

        case PRESET_TYPE.emoji:
            return (<Emoji colors={colors} uid={uid} />)

        case PRESET_TYPE.party:
            return (<Party colors={colors} uid={uid} />)

        case PRESET_TYPE.mountains:
            return (<Mountains colors={colors} uid={uid} />)

        case PRESET_TYPE.alphabet:
            return (<Alphabet colors={colors} uid={uid} />)

        case PRESET_TYPE.flowers:
            return (<Flowers colors={colors} uid={uid} />)

        case PRESET_TYPE.stripes:
            return (<Stripes colors={colors} uid={uid} />)

        case PRESET_TYPE.hourglass:
            return (<Hourglass colors={colors} uid={uid} />)

        case PRESET_TYPE.sale:
            return (<Sale colors={colors} uid={uid} />)

        case PRESET_TYPE.stones:
            return (<Stones colors={colors} uid={uid} />)

        case PRESET_TYPE.baloons:
            return (<Baloons colors={colors} uid={uid} />)

        case PRESET_TYPE.squares:
            return (<Squares colors={colors} uid={uid} />)

        case PRESET_TYPE.tictactoe:
            return (<TicTacToe colors={colors} uid={uid} />)

        case PRESET_TYPE.marble:
            return (<Marble colors={colors} uid={uid} />)

        case PRESET_TYPE.blot:
            return (<Blot colors={colors} uid={uid} />)

        case PRESET_TYPE.noses:
            return (<Noses colors={colors} uid={uid} />)

        case PRESET_TYPE.waves:
            return (<Waves colors={colors} uid={uid} />)

        case PRESET_TYPE.china:
            return (<China colors={colors} uid={uid} />)

        case PRESET_TYPE.crowns:
            return (<Crowns colors={colors} uid={uid} />)

        default:
            return (
                <g style={{ transformOrigin: 'center' }}>
                    <circle stroke={colors[0]} cx="12" cy="12" r="10" />
                </g>
            );
    }
}

const VANTA_TYPES = {
    BIRDS: 'birds',
    FOG: 'fog',
    WAVES: 'waves_3d',
    CLOUDS: 'clouds',
    CLOUDS_2: 'clouds_2',
    GLOBE: 'globe',
    NET: 'net',
    CELLS: 'cells',
    TRUNK: 'trunk',
    TOPOLOGY: 'topology',
    DOTS_3D: 'dots_3d',
    RINGS: 'rings',
    HALO: 'halo',
}

const CUSTOM_CANVAS_TYPES = {
    AURORA: 'aurora',
    COALESCE: 'coalesce',
    PIPELINE: 'pipeline',
    SHIFT: 'shift',
    SWIRL: 'swirl',
}

export const VANTA_ARRAY = [
    VANTA_TYPES.BIRDS,
    VANTA_TYPES.FOG,
    VANTA_TYPES.WAVES,
    VANTA_TYPES.CLOUDS,
    VANTA_TYPES.GLOBE,
    VANTA_TYPES.NET,
    VANTA_TYPES.CELLS,
    VANTA_TYPES.TRUNK,
    VANTA_TYPES.TOPOLOGY,
    VANTA_TYPES.DOTS_3D,
    VANTA_TYPES.RINGS,
    VANTA_TYPES.HALO,
]

export const CUSTOM_CANVAS_ARRAY = [
    CUSTOM_CANVAS_TYPES.AURORA,
    CUSTOM_CANVAS_TYPES.COALESCE,
    CUSTOM_CANVAS_TYPES.PIPELINE,
    CUSTOM_CANVAS_TYPES.SHIFT,
    CUSTOM_CANVAS_TYPES.SWIRL,
]

export const getSettingsForVanta = (type = '') => {
    const settings = []

    switch (type) {
        case VANTA_TYPES.BIRDS:
            settings.push({ name: 'color1', value: '#0000fc', type: 'color' });
            settings.push({ name: 'color2', value: '#fff000', type: 'color' });
            settings.push({
                name: 'colorMode', value: 'variance', type: 'select',
                options: [
                    { value: 'lerp', label: 'Lerp' },
                    { value: 'variance', label: 'Variance' },
                    { value: 'gradient', label: 'Gradient' },
                    { value: 'varianceGradient', label: 'Variance Gradient' }
                ]
            });
            settings.push({ name: 'quantity', value: 5, type: 'number', min: 1, max: 5, step: 1 });
            settings.push({ name: 'birdSize', value: 1.5, type: 'number', min: .5, max: 4, step: .1 });
            settings.push({ name: 'wingSpan', value: 30, type: 'number', min: 10, max: 40, step: 1 });
            settings.push({ name: 'speedLimit', value: 5, type: 'number', min: 1, max: 10, step: 1 });
            settings.push({ name: 'separation', value: 20, type: 'number', min: 1, max: 100, step: 1 });
            settings.push({ name: 'alignment', value: 20, type: 'number', min: 1, max: 100, step: 1 });
            settings.push({ name: 'cohesion', value: 20, type: 'number', min: 1, max: 100, step: 1 });
            break;

        case VANTA_TYPES.FOG:
            settings.push({ name: 'highlightColor', value: '#c1f2da', type: 'color' });
            settings.push({ name: 'midtoneColor', value: '#0077ff', type: 'color' });
            settings.push({ name: 'lowlightColor', value: '#2d00ff', type: 'color' });
            settings.push({ name: 'baseColor', value: '#ffebeb', type: 'color' });
            settings.push({ name: 'blurFactor', value: .6, type: 'number', min: .1, max: .9, step: .1 });
            settings.push({ name: 'zoom', value: .6, type: 'number', min: .1, max: 3, step: .1 });
            settings.push({ name: 'speed', value: 1, type: 'number', min: 0, max: 5, step: .5 });
            break;

        case VANTA_TYPES.WAVES:
            settings.push({ name: 'color', value: '#285ca7', type: 'color' });
            settings.push({ name: 'waveHeight', value: 23, type: 'number', min: 0, max: 40, step: 1 });
            settings.push({ name: 'waveSpeed', value: 1, type: 'number', min: 0, max: 2, step: .1 });
            settings.push({ name: 'zoom', value: 1, type: 'number', min: 1, max: 3, step: .1, info: 'only-publish' });
            settings.push({ name: 'shininess', value: 122, type: 'number', min: 0, max: 150, step: 5 });
            break;

        case VANTA_TYPES.CLOUDS:
            settings.push({ name: 'skyColor', value: '#68b8d7', type: 'color' });
            settings.push({ name: 'cloudColor', value: '#adc1de', type: 'color' });
            settings.push({ name: 'cloudShadowColor', value: '#183550', type: 'color' });
            settings.push({ name: 'sunColor', value: '#ffd100', type: 'color' });
            settings.push({ name: 'sunGlareColor', value: '#ff6633', type: 'color' });
            settings.push({ name: 'sunlightColor', value: '#ff9933', type: 'color' });
            settings.push({ name: 'speed', value: 1, type: 'number', min: 0, max: 3, step: .1 });
            break;

        case VANTA_TYPES.GLOBE:
            settings.push({ name: 'color', value: '#0e0072', type: 'color' });
            settings.push({ name: 'color2', value: '#00ff3c', type: 'color' });
            settings.push({ name: 'size', value: 2, type: 'number', min: 0.5, max: 2, step: .1 });
            break;

        case VANTA_TYPES.NET:
            settings.push({ name: 'color', value: '#3fddff', type: 'color' });
            settings.push({ name: 'points', value: 10, type: 'number', min: 1, max: 20, step: 1 });
            settings.push({ name: 'maxDistance', value: 20, type: 'number', min: 10, max: 40, step: 1 });
            settings.push({ name: 'spacing', value: 15, type: 'number', min: 10, max: 20, step: 1 });
            settings.push({ name: 'showDots', value: true, type: 'boolean' });
            break;

        case VANTA_TYPES.CELLS:
            settings.push({ name: 'color1', value: '#008c8c', type: 'color' });
            settings.push({ name: 'color2', value: '#af35f2', type: 'color' });
            settings.push({ name: 'size', value: .9, type: 'number', min: .2, max: 5, step: .1 });
            settings.push({ name: 'speed', value: 1, type: 'number', min: 0, max: 5, step: .1 });
            break;

        case VANTA_TYPES.TRUNK:
            settings.push({ name: 'color', value: '#60c841', type: 'color' });
            settings.push({ name: 'spacing', value: 1, type: 'number', min: 0, max: 10, step: 1 });
            settings.push({ name: 'chaos', value: 6, type: 'number', min: 0, max: 10, step: 1 });
            break;

        case VANTA_TYPES.TOPOLOGY:
            settings.push({ name: 'color', value: '#964e74', type: 'color' });
            break;

        case VANTA_TYPES.DOTS_3D:
            settings.push({ name: 'color', value: '#d42c78', type: 'color' });
            settings.push({ name: 'color2', value: '#f7f7f7', type: 'color', condition: {condProperty: 'showLines', value: true} });
            settings.push({ name: 'size', value: 5, type: 'number', min: 0.5, max: 10, step: .5 });
            settings.push({ name: 'spacing', value: 40, type: 'number', min: 5, max: 100, step: 5 });
            settings.push({ name: 'showLines', value: true, type: 'boolean' });
            break;

        case VANTA_TYPES.RINGS:
            settings.push({ name: 'ringsText', value: 'ringsText', type: 'text' })
            break;

        case VANTA_TYPES.HALO:
            settings.push({ name: 'baseColor', value: '#001a59', type: 'color' });
            settings.push({ name: 'size', value: 1, type: 'number', min: 0.1, max: 3, step: .1 });
            settings.push({ name: 'amplitudeFactor', value: 1, type: 'number', min: 0, max: 3, step: .1 });
            settings.push({ name: 'xOffset', value: 0, type: 'number', min: -.5, max: .5, step: .1 });
            settings.push({ name: 'yOffset', value: 0, type: 'number', min: -.5, max: .5, step: .1 });
            break;

        case CUSTOM_CANVAS_TYPES.AURORA:
            settings.push({ name: 'color', value: '#00ec53', type: 'color' });
            settings.push({ name: 'colorRange', value: 85, type: 'number', min: 0, max: 360, step: 5 });
            settings.push({ name: 'amount', value: 3, type: 'number', min: 1, max: 5, step: 1 });

            break;

        case CUSTOM_CANVAS_TYPES.COALESCE:
            settings.push({ name: 'color', value: '#ff0000', type: 'color' });
            settings.push({ name: 'colorRange', value: 120, type: 'number', min: 0, max: 360, step: 5 });
            settings.push({ name: 'amount', value: 7, type: 'number', min: 1, max: 15, step: 1 });
            settings.push({ name: 'speed', value: 1, type: 'number', min: .1, max: 2, step: .1 });
            break;

        case CUSTOM_CANVAS_TYPES.PIPELINE:
            settings.push({ name: 'color', value: '#14c86e', type: 'color' });
            settings.push({ name: 'colorRange', value: 60, type: 'number', min: 0, max: 360, step: 5 });
            settings.push({ name: 'amount', value: 7, type: 'number', min: 1, max: 50, step: 1 });
            settings.push({ name: 'speed', value: 1, type: 'number', min: .1, max: 2, step: .1 });
            break;

        case CUSTOM_CANVAS_TYPES.SHIFT:
            settings.push({ name: 'color', value: '#ff0000', type: 'color' });
            settings.push({ name: 'colorRange', value: 60, type: 'number', min: 0, max: 360, step: 5 });
            settings.push({ name: 'amount', value: 7, type: 'number', min: 1, max: 15, step: 1 });
            settings.push({ name: 'speed', value: 1, type: 'number', min: .1, max: 6, step: .1 });
            break;

        case CUSTOM_CANVAS_TYPES.SWIRL:
            settings.push({ name: 'color', value: '#5014c8', type: 'color' });
            settings.push({ name: 'colorRange', value: 60, type: 'number', min: 0, max: 360, step: 5 });
            settings.push({ name: 'amount', value: 7, type: 'number', min: 1, max: 25, step: 1 });
            settings.push({ name: 'speed', value: 1, type: 'number', min: .1, max: 2, step: .1 });
            break;
    }
    return settings
}

export const getVantaBackground = (type = '') => {
    switch (type) {
        case VANTA_TYPES.BIRDS:
            return 'rgba(208, 252, 252, 1)'
        case VANTA_TYPES.FOG:
            return 'rgba(193, 242, 218, 1)'
        case VANTA_TYPES.WAVES:
            return 'rgba(40, 92, 167, 1)'
        case VANTA_TYPES.CLOUDS:
            return 'rgba(104, 184, 215, 1)'
        case VANTA_TYPES.CLOUDS_2:
            return 'rgba(0, 0, 0, 1)'
        case VANTA_TYPES.GLOBE:
            return 'rgba(108, 78, 179, 1)'
        case VANTA_TYPES.NET:
            return 'rgba(24, 13, 49, 1)'
        case VANTA_TYPES.CELLS:
            return 'rgba(255, 255, 255, 1)'
        case VANTA_TYPES.TRUNK:
            return 'rgba(34, 52, 74, 1)'
        case VANTA_TYPES.TOPOLOGY:
            return 'rgba(164, 225, 225, 1)'
        case VANTA_TYPES.DOTS_3D:
            return 'rgba(24, 17, 24, 1)'
        case VANTA_TYPES.RINGS:
            return 'rgba(32, 36, 40, 1)'
        case VANTA_TYPES.HALO:
            return 'rgba(19, 26, 67, 1)'
        default:
            return 'rgba(32, 36, 40, 1)'

    }
}

export const getVantaPreview = (type = '') => {
    switch (type) {
        case VANTA_TYPES.BIRDS:
            return vanta_birds
        case VANTA_TYPES.FOG:
            return vanta_fog
        case VANTA_TYPES.WAVES:
            return vanta_waves
        case VANTA_TYPES.CLOUDS:
            return vanta_clouds
        case VANTA_TYPES.GLOBE:
            return vanta_globe
        case VANTA_TYPES.NET:
            return vanta_net
        case VANTA_TYPES.CELLS:
            return vanta_cells
        case VANTA_TYPES.TRUNK:
            return vanta_trunk
        case VANTA_TYPES.TOPOLOGY:
            return vanta_topology
        case VANTA_TYPES.DOTS_3D:
            return vanta_dots
        case VANTA_TYPES.RINGS:
            return vanta_rings
        case VANTA_TYPES.HALO:
            return vanta_halo
        case CUSTOM_CANVAS_TYPES.AURORA:
            return custom_aurora
        case CUSTOM_CANVAS_TYPES.COALESCE:
            return custom_coalesce
        case CUSTOM_CANVAS_TYPES.PIPELINE:
            return custom_pipeline
        case CUSTOM_CANVAS_TYPES.SHIFT:
            return custom_shift
        case CUSTOM_CANVAS_TYPES.SWIRL:
            return custom_swirl
        default:
            return vanta_birds
    }
}


const convertHexToHexCode = (hex) => {
    return parseInt(hex.replace('#', '0x'), 16);
};

const rgbaToHex = (rgba) => {
    const parts = rgba.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
    if (!parts) return null;

    const r = parseInt(parts[1], 10).toString(16).padStart(2, '0');
    const g = parseInt(parts[2], 10).toString(16).padStart(2, '0');
    const b = parseInt(parts[3], 10).toString(16).padStart(2, '0');

    return `#${r}${g}${b}`;
};

class Preset3D extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            VantaObject: null,
            downScale: .1
        }

        this.fps = 0
        this.fpsTimeStamp = Date.now()
        this.counterFpsUpdates = 0

        this.updateVantaTick = this.updateVantaTick.bind(this)
        this.countFPS = this.countFPS.bind(this)
        this.uniqueId = this.props.uid || Math.random().toString(36).substring(2, 15)

        this.fpsInterval = null
        this.fpsEnabled = false
    }

    componentDidMount() {
        this.init3D()
        if (!this.fpsEnabled && this.props.enableFpsStat) {
            this.fpsEnabled = true
            this.countFPS()
        }
        this.setState({ downScale: this.props.downScale })
    }

    componentDidUpdate(prevProps) {
        if (this.props.playState && !prevProps.playState) {
            this.play()
        } else if (!this.props.playState && prevProps.playState) {
            this.pause()
        }


    }

    componentWillUnmount() {
        if (this.state.VantaObject) {
            this.state.VantaObject.destroy()
        }
    }

    init3D() {
        if (CUSTOM_CANVAS_ARRAY.includes(this.props.backgroundType)) {
            this.initCustomHelperLib()
        } else {
            this.initVantaHelperLib()
        }
    }

    initCustomHelperLib() {
        const utilsScript = document.createElement('script')
        utilsScript.src = '/public/lib/canvas-custom/util.js'

        const initializeNoiseLib = () => {
            const noiseScript = document.createElement('script')
            noiseScript.src = '/public/lib/canvas-custom/noise.min.js'

            if (!document.querySelector(`script[src="${noiseScript.src}"]`)) {
                noiseScript.onload = () => {
                    this.initCustomLib()
                }
                document.body.appendChild(noiseScript)
            } else {
                this.initCustomLib()
                noiseScript.remove()
            }
        }

        if (!document.querySelector(`script[src="${utilsScript.src}"]`)) {
            utilsScript.onload = () => {
                initializeNoiseLib()
            }
            document.body.appendChild(utilsScript)

        } else {
            initializeNoiseLib()
            utilsScript.remove()
        }

    }

    initCustomLib() {
        const script = document.createElement('script')
        switch (this.props.backgroundType) {
            case CUSTOM_CANVAS_TYPES.AURORA:
                script.src = '/public/lib/canvas-custom/aurora.js'
                break;
            case CUSTOM_CANVAS_TYPES.COALESCE:
                script.src = '/public/lib/canvas-custom/coalesce.js'
                break;
            case CUSTOM_CANVAS_TYPES.PIPELINE:
                script.src = '/public/lib/canvas-custom/pipeline.js'
                break;
            case CUSTOM_CANVAS_TYPES.SHIFT:
                script.src = '/public/lib/canvas-custom/shift.js'
                break;
            case CUSTOM_CANVAS_TYPES.SWIRL:
                script.src = '/public/lib/canvas-custom/swirl.js'
                break;
        }




        script.onload = () => {
            this.initCustomCanvas()
        }
        document.body.appendChild(script)
    }

    initCustomCanvas() {
        if (!window.CustomCanvas) {
            return
        }
        const vantaContainerSelector = `#vanta-canvas-${this.uniqueId}`
        const vantaContainer = document.querySelector(vantaContainerSelector)
        // const settings = {
        //     color: '#ff0000',
        //     rangeHue: 300,
        //     noiseStrength: 100,
        //     backgroundColor: this.props.backgroundColor,
        //     amount: 5 * 100,
        //     speed: .8
        // }
        const defaultSettingsForTypeArray = getSettingsForVanta(this.props.backgroundType);

        const defaultSettingsForType = {}

        defaultSettingsForTypeArray.forEach((item) => {
            if (item.type === 'color') {
                defaultSettingsForType[item.name] = item.value
            } else if (item.type === 'number') {
                defaultSettingsForType[item.name] = item.value
            }
        })


       

        defaultSettingsForType.backgroundColor = this.props.backgroundColor
        const settings = { ...defaultSettingsForType, ...this.props.presetSettings }

        if (this.props.mobile) {
            
            if (this.props.backgroundType === CUSTOM_CANVAS_TYPES.SHIFT) {
                settings.baseRadius = 25
                settings.rangeRadius = 25
                settings.amount = Math.min(5, settings.amount)
            } else if (this.props.backgroundType !== CUSTOM_CANVAS_TYPES.PIPELINE) {
                settings.amount = 1
            }
        }

        // console.log('settings', {...settings})

        let customCanvasObject = null
        switch (this.props.backgroundType) {
            case CUSTOM_CANVAS_TYPES.AURORA:
                settings.amount = settings.amount * 100
                customCanvasObject = CustomCanvas.Aurora(vantaContainerSelector, settings)
                break;
            case CUSTOM_CANVAS_TYPES.COALESCE:
                settings.amount = settings.amount * 100
                customCanvasObject = CustomCanvas.Coalesce(vantaContainerSelector, settings)
                break;
            case CUSTOM_CANVAS_TYPES.PIPELINE:
                customCanvasObject = CustomCanvas.Pipeline(vantaContainerSelector, settings)
                break;
            case CUSTOM_CANVAS_TYPES.SHIFT:
                settings.amount = settings.amount * 10
                customCanvasObject = CustomCanvas.Shift(vantaContainerSelector, settings)
                break;
            case CUSTOM_CANVAS_TYPES.SWIRL:
                settings.amount = settings.amount * 100
                customCanvasObject = CustomCanvas.Swirl(vantaContainerSelector, settings)
                break;
        }
        this.setState({ VantaObject: customCanvasObject })


        vantaContainer.style.transition = '.6s'
        vantaContainer.style.opacity = 1

        this.tryInitializeFPSStat()


        if (!this.props.active) {
            setTimeout(() => {
                window.requestAnimationFrame(() => {
                    this.pause()
                })
            }, 100)

        }
    }

    initVantaHelperLib() {
        const script = document.createElement('script')
        switch (this.props.backgroundType) {
            case VANTA_TYPES.TRUNK:
            case VANTA_TYPES.TOPOLOGY:
                const p5Script = document.createElement('script')
                p5Script.src = 'https://cdnjs.cloudflare.com/ajax/libs/p5.js/1.1.9/p5.min.js'
                p5Script.onload = () => {
                    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r134/three.min.js'
                    script.onload = () => {
                        this.initVantaScript()
                    }
                    document.body.appendChild(script)
                }
                document.body.appendChild(p5Script)
                return
            default:
                script.src = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r134/three.min.js'
                break
        }

        if (document.querySelector(`script[src="${script.src}"]`)) {
            this.initVantaScript()
            return
        }

        script.onload = () => {
            this.initVantaScript()
        }

        document.body.appendChild(script)

    }

    initVantaScript() {
        const script = document.createElement('script')
        switch (this.props.backgroundType) {
            case VANTA_TYPES.BIRDS:
                script.src = 'https://cdn.jsdelivr.net/npm/vanta@0.5.24/dist/vanta.birds.min.js'
                break;
            case VANTA_TYPES.FOG:
                script.src = 'https://cdn.jsdelivr.net/npm/vanta@0.5.24/dist/vanta.fog.min.js'
                break;
            case VANTA_TYPES.WAVES:
                script.src = 'https://cdn.jsdelivr.net/npm/vanta@0.5.24/dist/vanta.waves.min.js'
                break;
            case VANTA_TYPES.CLOUDS:
                script.src = 'https://cdn.jsdelivr.net/npm/vanta@0.5.24/dist/vanta.clouds.min.js'
                break;
            case VANTA_TYPES.CLOUDS_2:
                script.src = 'https://cdn.jsdelivr.net/npm/vanta@0.5.24/dist/vanta.clouds2.min.js'
                break;
            case VANTA_TYPES.GLOBE:
                script.src = 'https://cdn.jsdelivr.net/npm/vanta@0.5.24/dist/vanta.globe.min.js'
                break;
            case VANTA_TYPES.NET:
                script.src = 'https://cdn.jsdelivr.net/npm/vanta@0.5.24/dist/vanta.net.min.js'
                break;
            case VANTA_TYPES.CELLS:
                script.src = 'https://cdn.jsdelivr.net/npm/vanta@0.5.24/dist/vanta.cells.min.js'
                break;
            case VANTA_TYPES.TRUNK:
                script.src = 'https://cdn.jsdelivr.net/npm/vanta@0.5.24/dist/vanta.trunk.min.js'
                break;
            case VANTA_TYPES.TOPOLOGY:
                script.src = 'https://cdn.jsdelivr.net/npm/vanta@0.5.24/dist/vanta.topology.min.js'
                break;
            case VANTA_TYPES.DOTS_3D:
                script.src = 'https://cdn.jsdelivr.net/npm/vanta@0.5.24/dist/vanta.dots.min.js'
                break;
            case VANTA_TYPES.RINGS:
                script.src = 'https://cdn.jsdelivr.net/npm/vanta@0.5.24/dist/vanta.rings.min.js'
                break;
            case VANTA_TYPES.HALO:
                script.src = 'https://cdn.jsdelivr.net/npm/vanta@0.5.24/dist/vanta.halo.min.js'
                break;
            default:
                break;
        }

        document.body.appendChild(script)

        script.onload = () => {
            this.initVanta()
        }
    }

    initVanta() {
        if (!VANTA) {
            return
        }

        let width = this.props.width
        let height = this.props.overflowHeight
        // const ratio = 970 / 365
        // if (this.props.width / this.props.height < ratio) {
        //     height = this.props.height
        //     width = (970 / 365) * height
        // }
        // if (this.props.downScale) {
        //     width = width * this.props.downScale
        //     height = height * this.props.downScale
        // }

        const backgroundColor = this.props.backgroundColor ? convertHexToHexCode(rgbaToHex(this.props.backgroundColor)) : null
        const backgroundAlpha = this.props.backgroundColor == 'transparent' ? 0 : 1
        let controls = true
        if (this.state.downScale < 1) {
            controls = false
        }
        const defaultSettings = {
            mouseControls: controls,
            touchControls: controls,
            gyroControls: false,
            minHeight: height * this.state.downScale,
            minWidth: width * this.state.downScale,
            scale: 1.00,
            scaleMobile: 1.00,
            backgroundAlpha: backgroundAlpha,
        }

        if (backgroundColor) {
            defaultSettings.backgroundColor = backgroundColor
        }

        const defaultSettingsForTypeArray = getSettingsForVanta(this.props.backgroundType);

        const defaultSettingsForType = { ...defaultSettings }

        defaultSettingsForTypeArray.forEach((item) => {
            if (item.type === 'color') {
                defaultSettingsForType[item.name] = convertHexToHexCode(item.value)
            } else if (item.type === 'number') {
                defaultSettingsForType[item.name] = item.value
            }
        })




        const settings = { ...defaultSettingsForType, ...this.props.presetSettings }
        if (this.props.presetSettings && this.props.presetSettings.backgroundColor) {
            settings.backgroundColor = convertHexToHexCode(this.props.presetSettings.backgroundColor)
        }
        console.log('settings', settings)

        const vantaContainerSelector = `#vanta-canvas-${this.uniqueId}`
        const vantaContainer = document.querySelector(vantaContainerSelector)
        const vantaImg = vantaContainer.querySelector('img')
        if (vantaImg) {
            vantaImg.remove()
        }
        let VantaObject = null
        switch (this.props.backgroundType) {
            case VANTA_TYPES.BIRDS:
                VantaObject = VANTA.BIRDS({
                    el: vantaContainerSelector,
                    ...settings
                })
                break;
            case VANTA_TYPES.FOG:
                VantaObject = VANTA.FOG({
                    el: vantaContainerSelector,
                    ...settings
                })
                break;
            case VANTA_TYPES.WAVES:
                VantaObject = VANTA.WAVES({
                    el: vantaContainerSelector,
                    ...settings
                })
                break;
            case VANTA_TYPES.CLOUDS:
                VantaObject = VANTA.CLOUDS({
                    el: vantaContainerSelector,
                    ...settings
                })
                break;
            case VANTA_TYPES.CLOUDS_2:
                VantaObject = VANTA.CLOUDS2({
                    el: vantaContainerSelector,
                    ...settings
                })
                break;
            case VANTA_TYPES.GLOBE:
                VantaObject = VANTA.GLOBE({
                    el: vantaContainerSelector,
                    ...settings
                })
                break;
            case VANTA_TYPES.NET:
                VantaObject = VANTA.NET({
                    el: vantaContainerSelector,
                    ...settings
                })
                break;
            case VANTA_TYPES.CELLS:
                VantaObject = VANTA.CELLS({
                    el: vantaContainerSelector,
                    ...settings
                })
                break;
            case VANTA_TYPES.TRUNK:
                VantaObject = VANTA.TRUNK({
                    el: vantaContainerSelector,
                    ...settings
                })
                break;
            case VANTA_TYPES.TOPOLOGY:
                VantaObject = VANTA.TOPOLOGY({
                    el: vantaContainerSelector,
                    ...settings
                })
                break;
            case VANTA_TYPES.DOTS_3D:
                VantaObject = VANTA.DOTS({
                    el: vantaContainerSelector,
                    ...settings
                })
                break;
            case VANTA_TYPES.RINGS:
                VantaObject = VANTA.RINGS({
                    el: vantaContainerSelector,
                    ...settings
                })
                break;
            case VANTA_TYPES.HALO:
                VantaObject = VANTA.HALO({
                    el: vantaContainerSelector,
                    ...settings
                })
                break;
            default:
                break;
        }




        this.setState({ VantaObject })
        const container = document.querySelector(vantaContainerSelector)

        container.style.transition = '.6s'
        container.style.opacity = 1

        this.tryInitializeFPSStat()
        if (!this.props.active) {
            const stopInterval = setInterval(() => {
                if (this.state.VantaObject) {
                    this.stopVantaWithScreenshot()
                }
                clearInterval(stopInterval)
            }, 100)
        }

        
    }

    tryInitializeFPSStat() {
        if (this.props.enableFpsStat && this.fpsInterval === null && this.props.active) {
            this.fpsInterval = setInterval(() => {
                this.updateVantaTick()
            }, 1000)
        }

        // this.checkFPSInterval = setInterval(() => {
        //     this.checkFPS()
        // }, 1000)
    }

    stopVantaWithScreenshot() {
        requestAnimationFrame(() => {
            const vantaContainerSelector = `#vanta-canvas-${this.uniqueId}`
            const container = document.querySelector(vantaContainerSelector)

            const canvases = container.querySelectorAll('canvas')

            if (canvases.length != 0) {
                const canvasThreeJS = canvases[0]
                const canvasP5 = canvases[1]

                if (canvasThreeJS && canvasP5) {
                    const dataURL = canvasP5.toDataURL('image/png', 1.0)
                    const img = document.createElement('img')
                    img.src = dataURL
                    img.style.width = '100%'
                    img.style.height = '101%'
                    img.style.position = 'absolute'
                    img.style.top = '0'
                    img.style.left = '0'
                    container.appendChild(img)
                    if (this.state.VantaObject) {
                        this.state.VantaObject.destroy()
                    }
                    canvasThreeJS.remove()
                } else {
                    const dataURL = canvasThreeJS.toDataURL('image/png', 1.0)
                    const img = document.createElement('img')
                    img.src = dataURL
                    img.style.width = '100%'
                    img.style.height = '101%'
                    img.style.position = 'absolute'
                    img.style.top = '0'
                    img.style.left = '0'
                    container.appendChild(img)
                    if (this.state.VantaObject) {
                        this.state.VantaObject.destroy()
                    }
                    canvasThreeJS.remove()
                }
            }
        })

    }

    pause() {
        console.log('pause canvas')
        if (VANTA_ARRAY.includes(this.props.backgroundType)) {
            this.stopVantaWithScreenshot()
        } else {
            this.state.VantaObject.pause()

        }
    }

    play() {
        console.log('play canvas')
        // this.state.VantaObject.animationLoop = this.state.VantaObject.oldAnimationLoop
        // this.state.VantaObject.animationLoop()
        // console.log(this.state.VantaObject.animationLoop)

        if (VANTA_ARRAY.includes(this.props.backgroundType)) {
            this.initVanta()
        } else {
            this.state.VantaObject.play()
        }
    }

    decreaseQuality() {
        if (this.state.qualityDecreased || !this.state.VantaObject) {
            return
        }
        if (VANTA_ARRAY.includes(this.props.backgroundType)) {
            console.log('decrease quality new quality:', this.state.downScale * .7)
            this.pause()
            this.setState(prevState => ({ downScale: prevState.downScale * .7 }))
            setTimeout(() => {
                this.play()
            }, 1000)
            this.setState({ qualityDecreased: true })
            setTimeout(() => {
                this.setState({ qualityDecreased: false })
            }, 5000)
        }
    }

    countFPS() {        
        this.fps += Math.round(1000 / (Date.now() - this.fpsTimeStamp))
        this.fpsTimeStamp = Date.now()
        this.counterFpsUpdates++
        window.requestAnimationFrame(this.countFPS)
    }

    checkFPS() {
        let fps = (this.fps / this.counterFpsUpdates).toFixed(0) || 1
        isNaN(fps) && (fps = 1)

        console.log('check fps', fps)

        if (fps != 1 && fps < 30) {
            this.decreaseQuality()
        }
    }

    updateVantaTick() {
        const fpsContainer = document.querySelector('#vanta-fps')
        let fps = (this.fps / this.counterFpsUpdates).toFixed(0) || 1
        isNaN(fps) && (fps = 1)
        this.fps = 0
        this.counterFpsUpdates = 0

        if (!fpsContainer) {
            const fpsCreated = document.createElement('div')
            fpsCreated.id = 'vanta-fps'
            fpsCreated.style.position = 'fixed'
            fpsCreated.style.top = '15px'
            fpsCreated.style.right = '15px'
            fpsCreated.style.zIndex = 9999
            fpsCreated.style.color = 'white'
            fpsCreated.style.fontSize = '20px'
            fpsCreated.style.backgroundColor = 'rgba(0, 0, 0, 0.5)'
            fpsCreated.style.padding = '10px'
            fpsCreated.style.borderRadius = '5px'
            fpsCreated.style.pointerEvents = 'none'
            fpsCreated.style.userSelect = 'none'
            fpsCreated.style.fontFamily = 'Arial, sans-serif'
            fpsCreated.style.fontWeight = 'bold'
            fpsCreated.style.transition = 'opacity 0.3s ease-in-out'
            fpsCreated.innerHTML = `FPS: ${fps}`
            document.body.appendChild(fpsCreated)
        } else {
            fpsContainer.innerHTML = `FPS: ${fps}`
        }
    }

    render() {
        let width = this.props.width
        let height = this.props.overflowHeight

        const style = { 
            width: `100%`, 
            height: `100%`, 
            position: 'absolute', 

            transformOrigin: 'center center', 
            opacity: 0,
            left: `0px`,
            // left: `${left}px`,
            top: `0px`,

        }

        if (this.state.downScale != 1) {
            style.transform = `scale(${1 / this.state.downScale})`
            style.width = `${width * this.state.downScale}px`
            style.height = `${height * this.state.downScale}px`
            style.top = `${(height - height * this.state.downScale) / 2}px`
            style.left = `${(width - width * this.state.downScale) / 2}px`
        }

        // return (
        //     <div style={{ width: `${widthNoScale}px`, height: `${overflowHeight}px`, position: 'absolute', top: 0, left: 0, overflow: 'hidden' }}>
        //         <div className={this.props.className} id={`vanta-canvas-${this.uniqueId}`} style={style}>
        //         </div>
        //     </div>
        // )
        return (
            <div style={{ width: `${width}px`, height: `${height}px`, position: 'absolute', top: 0, left: 0, overflow: 'hidden' }}>
                <div className={this.props.className} id={`vanta-canvas-${this.uniqueId}`} style={style}>
                </div>
            </div>
        )
    }
}

export const RenderPreset = (props = { colors: [], uid: `widget`, type: PRESET_TYPE.circles, style: {}, className: '', width: window.innerWidth, height: window.innerHeight, overflowHeight: 200, presetSettings: {}, active: false, backgroundColor: '', enableFpsStat: false, playState: true, mobile: false }) => {
    let width = props.width
    let height = (365 / 970) * width
    const ratio = 970 / 365
    if (props.width / props.height < ratio) {
        height = props.height
        width = (970 / 365) * height
    }
    const left = (props.width - width) / 2
    const overflowHeight = props.overflowHeight || height

    const is3DPreset = VANTA_ARRAY.includes(props.type) || CUSTOM_CANVAS_ARRAY.includes(props.type)

    if (is3DPreset) {
        let downScale = 1
        if (props.type === VANTA_TYPES.CLOUDS) {
            downScale = .2
        }
        return (
            <Preset3D
                width={props.width}
                height={props.height}
                overflowHeight={props.overflowHeight}
                className={props.className}
                // backgroundType={props.type}
                backgroundType={props.type}
                presetSettings={props.presetSettings}
                backgroundColor={props.backgroundColor === 'transparent' ? 'rgba(0, 0, 0, 0)' : props.backgroundColor}
                enableFpsStat={props.enableFpsStat}
                active={props.active}
                playState={props.playState}
                downScale={downScale}
                mobile={props.mobile}
            />
        )
    }



    return (
        <div style={{ width: `${width}px`, height: `${overflowHeight}px`, position: 'absolute', top: 0, left: 0, overflow: 'hidden' }}>
            <div className={props.className} style={{ width: `${width}px`, height: `${height}px`, left: `${left}px`, position: 'absolute', top: '50%', transform: `translateY(calc(-50%))`, transformOrigin: 'center center', backgroundColor: 'transparent', pointerEvents: 'none' }}>
                <svg
                    fill="none"
                    style={{ ...props.style, position: 'absolute', top: '50%', transform: 'translateY(-50%)' }}
                    viewBox={getViewBoxByType(props.type)}
                    width={'100%'}
                    height={'100%'}
                >
                    {getPathsByType(props.type, props.colors, props.uid)}
                </svg>
            </div>
        </div>

    )
}